import React, { Component } from 'react'
import i18n from 'live/services/i18n'
import { Modal, Alert } from 'react-bootstrap'
import xhr from 'live/services/xhr'
import FormGroup from 'live/components/forms/ui/form-group'
import TableForm from 'live/components/forms/ui/table-form'
import LiveSelect from 'live/components/forms/ui/select'
import _ from 'lodash'
import styled from 'styled-components'
import theme from 'live/services/theme'
import OldMnemonicTooltipInfo from './OldMnemonicTooltipInfo'
import SamterApi from '../api'
import serviceLocator from 'live/services/service-locator'
import Select from 'react-select'

const RIGS_URL = '/services/plugin-liverig/assets/rig'

const POOLTIME = 5000
const WAIT_INTERVAL = 1000
const ENTER_KEY = 13
const MAX_RETRY = 20
let RETRY = 0

type Props = {
    rigName: string,
    rigId: string,
    data: Array<>,
    wellName: string,
    config: object,
    show: boolean,
    onHide: void => void,
    onApply: Function,
    index: string,
    object: Record<String, any>
}

type State = {
    rigName: string,
    rigId: string,
    points: Array<>,
    data: Array<>,
    loading: boolean,
    error: string,
    wellName: string,
    rigs: Array<>,
    rigMap: Array<>,
    availableCurves: Array<>
}

function defineParams(config, nameFilter, object) {
    return {
        base: [config.uri],
        path: ['\\\\' + config.server_path],
        username: [config.username],
        password: [config.password],
        nameFilter: [nameFilter],
        qualifier: [(object?.qualifier ? (object?.type + '/' + object?.qualifier) : object?.type) || '']
    }
}

export default class WellConfigModal extends Component<Props, State> {

    constructor(props) {
        super(props)

        this.state = {
            rigName: props.rigName || '',
            rigId: props.rigId || '',
            points: [],
            dataPoints: {},
            data: props.data || [],
            loading: false,
            error: null,
            wellName: props.wellName || '',
            rigs: [],
            rigMap: [],
            availableCurves: [],
            mapCurve: {}
        }
        this.getDataPoints = this.getDataPoints.bind(this)
    }

    handleWellChange = target => {
        this.onChangeInput(target)
        this.triggerChange()
    }

    handleKeyDown = e => {
        if (e.keyCode === ENTER_KEY) {
            this.triggerChange.cancel()
            this.getPoints()
        }
    }

    componentDidMount() {
        this.getDataPoints()
        xhr.get(RIGS_URL)
            .then(resp => {
                if (resp != null) resp = resp.data
                if (resp != null) {
                    const rigs = resp.map(i => ({ value: i.name, label: i.name }))
                    const rigMap = resp.reduce((obj, item) => {
                        obj[item.name] = item.id
                        return obj
                    }, {})
                    this.setState({ rigs, rigMap })
                }
            })
            .catch(console.error)

        serviceLocator.getService('liverig-curves-api').then(curvesService => {
            curvesService.api.get(curves => {
                _.forEach(curves, (curve, mnemonic) => {
                    curve['mnemonic'] = mnemonic
                })
                const curveOptions = _.map(_.sortBy(curves, curve => curve.description.toLowerCase()), curve => {
                    return { value: curve.mnemonic, label: curve.description }
                })
                const mapCurve = _.keyBy(curveOptions, 'value')
                this.setState({ availableCurves: curveOptions, mapCurve })
            })
        })
        // I don't have the WellName anymore
        if (this.state.wellName) this.getPoints()
    }

    getDataPoints() {
        let nameFilter = this.props.wellName + '*'
        let filters = this.state.data.filter(d => d.nameFilter).map(d => d.nameFilter)

        if (!filters.find(f => f === nameFilter)) filters.push(nameFilter)
        let promises = filters.map(f => this.getPointsByNameFilter(f))

        this.setState({ loading: true })

        Promise.all(promises).then(resolve => {
            let dataPoints = {}
            let error = null

            resolve.forEach(r => {
                if (r.nameFilter) dataPoints[r.nameFilter] = r.points

                error = r.error
            })
            if (error) {
                this.setState({ loading: false, error })
                if (RETRY <= MAX_RETRY) {
                    RETRY++
                    this.poolTimeout = setTimeout(() => this.getDataPoints(), POOLTIME)
                }

                return
            }
            this.setState({ loading: false, dataPoints, error })
        })
    }


    componentWillUnmount = () => {
        this.triggerChange.cancel()
    }

    serverVerify = () => {
        let { config, object } = this.props
        let { wellName } = this.state
        
        const nameFilter = wellName + '*'
        let params = defineParams(config, nameFilter, object)

        SamterApi.post(
            params,
            data => {
                if (!_.isEqual(this.state.points, data.Items))
                    this.setState({
                        points: data.Items,
                        error: null
                    })
            },
            data => {
                if (!_.isEqual(this.state.error, data.message))
                    this.setState({
                        error: data.message
                    })
            }
        )
    }

    getPointsByNameFilter = nameFilter => {
        let { config, object } = this.props
        
        let params = defineParams(config, nameFilter, object)

        return new Promise((resolve) => {
            SamterApi.post(params, data => {
                resolve({ points: data.Items, nameFilter: nameFilter, error: null })
            }, e => {
                resolve({
                    error: (e && e.data && e.data.message) || i18n('undefined error')
                })
            })
        })
    }

    getPoints = () => {
        let { config, object } = this.props
        let { wellName } = this.state

        const nameFilter = wellName + '*'
        let params = defineParams(config, nameFilter, object)

        this.setState({ loading: true })

        SamterApi.post(
            params,
            data => {
                this.setState({
                    points: (data && data.Items) || [],
                    loading: false,
                    error: null
                })
            },
            data => {
                this.setState({
                    loading: false,
                    error: data || ''
                })
            },
            null
        )
    }

    triggerChange = _.debounce(this.getPoints, WAIT_INTERVAL)

    onChangeInput = ({ target }) => {
        let { name, value } = target

        this.setState({
            [name]: value
        })
    }

    onChange = data => {
        let { dataPoints } = this.state

        dataPoints = _.clone(dataPoints)
        data.forEach(d => {
            if (d && d.filter && d.filter.nameFilter) {
                dataPoints[d.filter.nameFilter] = d.filter.points
                d.filter = undefined
            }
        })

        if (this.state.error) {
            const error = this.validate(data) ? '' : this.state.error
            this.setState({ data, error, dataPoints })
        } else {
            this.setState({ data, dataPoints })
        }
    }

    validate = (data: Object) => {
        return _.reduce(
            data,
            (acc, cur) => acc && (!!cur.property || !(cur.curve || cur.unit || cur.mnemonic)),
            true
        )
    }
    apply = () => {
        let { rigName, rigId, data, wellName, rigs, rigMap } = this.state
        let { index } = this.props

        if (this.validate(data)) {
            let validData = _.filter(data, d => d.property)
            let curves = _.map(validData, d => d.curve).join(', ')

            this.props.onApply(index, {
                name: wellName,
                rig: rigName,
                rigId: rigId || (rigMap && rigMap[rigName]),
                config: validData,
                curves
            })
            this.props.onHide()
        } else {
            this.setState({ error: i18n('Select a property to import') })
        }
    }

    mapData = () => {
        const { points, data } = this.state

        if (points.length > 0)
            return _.map(points, item => ({
                label: item.Name,
                value: item.WebId
            }))
        let filteredData = _.uniqBy(data, 'name')

        filteredData = _.filter(filteredData, o => !_.isEmpty(o.name))

        return _.map(filteredData, item => ({
            label: item.name,
            value: item.property
        }))
    }

    render() {
        let { rigName, data, points, loading, error, wellName, availableCurves, mapCurve, rigs, rigMap, dataPoints } = this.state



        return (
            <Modal
                show={this.props.show}
                className="samter-well-config-modal"
                onHide={this.props.onHide}
                animation={false}
            >
                <Modal.Header>
                    <Modal.Title>{`${i18n('Well')}: ${this.state.wellName}`}</Modal.Title>
                </Modal.Header>
                <Modal.Body className={loading ? 'loading' : ''}>
                    {error ? (
                        <div className="row">
                            <div className="col-md-12">
                                <Alert bsStyle="danger">
                                    <p>{error}</p>
                                </Alert>
                            </div>
                        </div>
                    ) : (
                            ''
                        )}

                    <div className="config-form">
                        <FormGroup
                            type="text"
                            name="wellName"
                            value={wellName}
                            label={
                                <React.Fragment>
                                    {i18n('Well name')}
                                    <Comment>{i18n('(known by SAMTER)')}</Comment>
                                    <Required>*</Required>
                                </React.Fragment>
                            }
                            onChange={this.handleWellChange}
                            onKeyDown={this.handleKeyDown}
                            validationState={!wellName ? 'error' : 'success'}
                            hasFeedback
                            help={!wellName ? i18n('Well name is required') : ''}
                        />
                        <LiveSelect
                            label={
                                <React.Fragment>
                                    {i18n('Rig')}
                                    <Comment>{i18n('(known by LIVE)')}</Comment>
                                    <Required>*</Required>
                                </React.Fragment>
                            }
                            name="rigName"
                            value={rigName}
                            onChange={id => this.setState({ rigName: id, rigId: rigMap[id] })}
                            disabled={false}
                            placeholder={i18n('Select an asset')}
                            options={rigs}
                            validationState={!rigName ? 'error' : 'success'}
                            searchable={true}
                            hasFeedback
                            help={!rigName ? i18n('Rig name is required') : ''}
                        />
                    </div>

                    <TableForm
                        visibleRows={1}
                        hasFeedback={true}
                        fields={[
                            {
                                label: <> {i18n('Property to import')}
                                    <Required>*</Required></>,
                                name: 'property',
                                type: 'component',
                                Component: e => {
                                    return (
                                        <SelectProperty
                                            dataPoints={dataPoints}
                                            mapData={this.mapData()}
                                            config={this.props.config}
                                            value={e.value}
                                            nameFilter={e.data.nameFilter}
                                            data={e.data}
                                            onChange={e.onChange}
                                            points={points}
                                            collectionName={wellName}
                                            object={this.props.object}
                                        />
                                    )
                                },
                                placeholder: i18n('Choose a property'),
                                options: !error
                                    ? _.map(points, point => ({
                                        label: point.Name,
                                        value: point.WebId
                                    }))
                                    : this.mapData(),
                                searchable: true,
                                clearable: true,
                                cols: 4,
                                required: true
                            },
                            {
                                label: i18n('Unit'),
                                name: 'unit',
                                type: 'text',
                                cols: 1
                            },
                            {
                                label: i18n('SAMTER Standard Channel'),
                                name: 'curve',
                                type: 'text',
                                cols: 3
                            },
                            {
                                label: <>{i18n('Target channel')}
                                    <Required>*</Required></>,
                                name: 'mnemonic',
                                options: availableCurves,
                                searchable: true,
                                type: 'select',
                                cols: 3
                            },
                            {
                                label: '',
                                name: 'name',
                                type: 'component',
                                Component: (props) => {
                                    return <OldMnemonicTooltipInfo {...props} isWarning={!mapCurve[props.data.mnemonic]}></OldMnemonicTooltipInfo>
                                },
                                cols: 1
                            }
                        ]}
                        data={data}
                        hasClear={true}
                        onChange={this.onChange}
                        hideAddButton={false}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-primary"
                        disabled={loading || error || !rigName || !wellName}
                        onClick={this.apply}
                    >
                        {i18n('Apply')}
                    </button>
                    <span>
                        {i18n('or')} <a onClick={this.props.onHide}>{i18n('cancel')}</a>
                    </span>
                    <RequiredFooter>
                        <Required>*</Required>
                        {i18n('Required')}
                    </RequiredFooter>
                </Modal.Footer>
            </Modal>
        )
    }

}

class SelectProperty extends Component<Props> {

    constructor(props) {
        super(props)
        this.state = {
            nameFilter: props.nameFilter || props.collectionName + '*',
            points: props.dataPoints[props.nameFilter || props.collectionName + '*'] || [],
            mapData: this.props.mapData
        }
        this.nameFilter = props.nameFilter || props.collectionName + '*'
        this.getPoints = _.debounce(this.getPoints.bind(this), 300)
    }

    getPoints(nameFilter) {
        let self = this
        let { config, object } = this.props

        let params = defineParams(config, nameFilter, object)

        this.setState({ loading: true })

        SamterApi.post(params, data => {
            self.setState({
                points: data.Items,
                loading: false,
                error: null
            })
        }, data => {
            self.setState({
                loading: false,
                error: data.message
            })
            if (RETRY <= MAX_RETRY) {
                RETRY++
                this.poolTimeout = setTimeout(() => this.getPoints(nameFilter), POOLTIME)
            }
        })
    }


    componentWillUnmount = () => {
        if (this.poolTimeout)
            clearTimeout(this.poolTimeout)
    }

    onChange(e) {
        if (e == null) {
            this.props.data.nameFilter = null
            if (this.props.onChange) this.props.onChange('property', null)

            return
        }
        this.props.data.filter = { nameFilter: this.nameFilter, points: this.state.points }
        this.props.data.nameFilter = this.nameFilter
        if (this.props.onChange) this.props.onChange('property', e.value)
    }

    onInputChange(text) {
        if (!this.state.points) return
        let hasSome = this.state.points.find(p => p.Name.startsWith(text))

        if (!hasSome) {
            this.nameFilter = text + '*'
            this.getPoints(this.nameFilter)
        }
    }

    render() {
        let { points, loading, mapData } = this.state

        return (
            <Select
                placeholder={i18n('Choose a property')}
                options={
                    points && Array.isArray(points) && points.length > 0
                        ? _.map(points, (point, i) => ({
                            label: point.Name,
                            value: point.WebId
                        }))
                        : mapData || []
                }
                searchable={true}
                isLoading={loading}
                isDisabled={loading}
                clearable={true}
                className="Select-small"
                noResultsText={i18n('No results found')}
                value={this.props.value}
                onChange={e => this.onChange(e)}
                onInputChange={text => this.onInputChange(text)}
            />
        )
    }

}

const Required = styled.span`
    color: ${theme['light-red']};
`
const RequiredFooter = styled.div`
    position: absolute;
    bottom: 24px;
    right: 24px;
    color: ${theme['auxiliar-typography']};
`
const Comment = styled.span`
    color: ${theme['icons']};
`
